module.exports = __webpack_public_path__ + "media/images/Waterfall-5c5c621f.jpg";